import { Auth } from "@/services/firebase/auth"
import { DB } from "@/services/firebase/db"
import { Storage } from "@/services/firebase/storage"
import firebase from "firebase/compat"
import User from "@/types/account/user"

export class AccountService {
  uploadProfilePicture (file: File, existingFileName?: string) {
    const storageRef = Storage.ref()
    const fileName = file.name.replace(/\s/g, '')
    const mountainsRef = storageRef.child(`images/${Auth.currentUser?.uid + '_' + encodeURI(fileName)}`)
    this.deleteOldProfilePicture(Auth.currentUser?.uid, existingFileName)
    return mountainsRef.put(file)
      .then(snapshot => {
        return snapshot.ref.getDownloadURL()
          .then((downloadURL) => {
            downloadURL = downloadURL.replace(process.env.VUE_APP_STORAGE_BASE_URL || '', '')
            return DB.collection('users').doc(Auth.currentUser?.uid).set({
              profilePicture: downloadURL
            }, { merge: true })
              .then(() => {
                return downloadURL
              })
          })
      })
  }

  uploadCompanyLogo (file: File, existingFileName?: string) {
    const storageRef = Storage.ref()
    const fileName = file.name.replace(/\s/g, '')
    const mountainsRef = storageRef.child(`images/companyLogos/${Auth.currentUser?.uid + '_' + encodeURI(fileName)}`)
    this.deleteOldCompanyLogo(Auth.currentUser?.uid, existingFileName)
    return mountainsRef.put(file)
      .then(snapshot => {
        return snapshot.ref.getDownloadURL()
          .then((downloadURL) => {
            downloadURL = downloadURL.replace(process.env.VUE_APP_STORAGE_BASE_URL || '', '')
            return DB.collection('users').doc(Auth.currentUser?.uid).set({
              companyLogo: downloadURL
            }, { merge: true })
              .then(() => {
                return downloadURL
              })
          })
      })
  }

  uploadCompanyColor (companyColor: string) {
    return DB.collection('users').doc(Auth.currentUser?.uid).set({
      companyColor: companyColor
    }, { merge: true })
      .then(() => {
        return companyColor
      })
  }

  deleteOldProfilePicture (userId?: string, existingFileName?: string) {
    if (existingFileName && userId) {
      const file = existingFileName.match(`${userId}(.*)((.png)|(.bmp)|(.jpg)|(.jpeg))`)
      if (file && file.length > 0) {
        const imageReference = Storage.ref('images/' + file[0])
        imageReference.delete()
          .catch((error) => {
            console.log(error)
          })
      }
    }
  }

  deleteOldCompanyLogo (userId?: string, existingFileName?: string) {
    if (existingFileName && userId) {
      const file = existingFileName.match(`${userId}(.*)((.png)|(.bmp)|(.jpg)|(.jpeg))`)
      if (file && file.length > 0) {
        const imageReference = Storage.ref('images/companyLogos/' + file[0])
        imageReference.delete()
          .catch((error) => {
            console.log(error)
          })
      }
    }
  }

  getUserId (email: string) {
    return DB.collection('users')
      .where('email', '==', email.toLowerCase()).limit(1)
      .get()
      .then((userQuery) => {
        if (userQuery.docs && userQuery.docs.length > 0) {
          return userQuery.docs[0].id
        } else {
          return null
        }
      })
  }

  getUserById (id: string) {
    return DB.collection('users')
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          return new User({
            id: doc.id,
            ...doc.data()
          })
        }
      })
  }

  getUsersByIds (ids: (string | null)[]) {
    return DB.collection('users')
      .where(firebase.firestore.FieldPath.documentId(), 'in', ids)
      .get()
      .then((userQuery) => {
        return userQuery.docs.map((user) => {
          return new User({
            id: user.id,
            ...user.data()
          })
        })
      })
  }
}
